import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { LoginPopUp } from '..';
import { useStatsig } from '../../hooks/useStatsig';
import { useBraze } from '../../hooks/useBraze';

const LoginPopUpWrapper = (props) => {
    const { checkGate, featureGates } = useStatsig();
    const isNewLoginPopUpFlagEnabled = checkGate(featureGates.NEW_LOGIN_POPUP);
    const { brazeInstance } = useBraze();
    const userId = useSelector(({ auth }) => auth?.user?.id);

    useEffect(() => {
        if (brazeInstance && userId) {
            const brazeUserId = parseInt(brazeInstance.getUser().getUserId(), 10);
            if (brazeUserId !== userId) {
                brazeInstance.changeUser(userId);
            }
        }
    }, [brazeInstance, userId]);

    return (
        <LoginPopUp isNewLoginPopUpFlagEnabled={isNewLoginPopUpFlagEnabled} {...props} />
    );
};

export default LoginPopUpWrapper;
